import { SeQuestionStatus } from "../../../autogen/bff-api";

export const QUESTION_STATUS_COLORS: Record<SeQuestionStatus, { bg: string; fg: string }> = {
  [SeQuestionStatus.Unanswered]: { bg: "smChipAmberBg", fg: "smChipAmberFg" },
  [SeQuestionStatus.Answered]: { bg: "smChipBlueBg", fg: "smChipBlueFg" },
  [SeQuestionStatus.Published]: { bg: "smChipGreenBg", fg: "smChipGreenFg" },
};
